import React from 'react'

import { useActions, useAppSelector } from 'redux/hooks'
import { toggleModal as toggleModalAction } from 'redux/active/actions'

import { CategoryType } from 'types/deck'

import Modal from 'components/elements/Modal'
import CategoryForm from 'components/deckPage/categories/Form'

import styles from './categoryModal.module.scss'

type Props = {
  open: boolean
  category?: CategoryType
  onClose: () => void
  onSave?: (createdOrUpdatedCategory: CategoryType) => void
  isTemplate?: boolean
  personalCategoriesPage?: boolean
}

const CategoryModal = ({
  open,
  category,
  onClose,
  onSave,
  isTemplate = false,
  personalCategoriesPage = false,
}: Props) => {
  return (
    <Modal open={open} onClose={onClose} modalClassName={styles.modal} closeButton>
      {!!category?.name && <h3>Edit {category.name}</h3>}
      {!category?.name && <h3>Create Category {isTemplate && 'Template'}</h3>}

      <CategoryForm
        category={category}
        onChange={onSave}
        isTemplate={isTemplate}
        personalCategoriesPage={personalCategoriesPage}
      />
    </Modal>
  )
}

export default CategoryModal

export const GlobalCateogoryModal = () => {
  const category = useAppSelector(state => state.active.modals.editCategory)

  const [toggleModal] = useActions(toggleModalAction)

  const handleClose = () => toggleModal('editCategory', null)

  return (
    <CategoryModal
      key={category?.name}
      open={!!category}
      category={category}
      onClose={handleClose}
      onSave={handleClose}
    />
  )
}
